import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const Block = ({ n, title, children }) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-b border-[#0A192F]/10">
    <div className="md:col-span-3">
      <div className="font-mono text-xs text-[#F59E0B] mb-2">{n}</div>
      <h2 className="font-serif text-2xl text-[#0A192F]">{title}</h2>
    </div>
    <div className="md:col-span-9 text-[#4A5568] text-sm leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <header className="border-b border-[#0A192F]/10 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <nav className="flex gap-6 text-sm">
            <Link to="/security" className="text-[#4A5568]">Security</Link>
            <Link to="/privacy" className="text-[#4A5568]">Privacy</Link>
            <Link to="/terms" className="text-[#0A192F] font-medium">Terms</Link>
          </nav>
        </div>
      </header>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="font-overline text-[#4A5568] mb-4">Terms of service</div>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight text-[#0A192F]">The deal, in plain terms.</h1>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        <Block n="01" title="The service">
          <p>NTN provides a software platform for ordering and managing tenant background screening reports. Reports are produced by NTN and/or trusted third-party data providers.</p>
        </Block>
        <Block n="02" title="Your account">
          <p>You're responsible for keeping credentials confidential, enabling MFA where appropriate, and notifying us at security@ntnverify.com of suspected compromise.</p>
        </Block>
        <Block n="03" title="Permissible use (FCRA)">
          <p>Reports may only be ordered for a permissible purpose under the Fair Credit Reporting Act (15 U.S.C. § 1681b). Typically: with applicant written consent, in connection with a tenancy decision.</p>
          <p>You agree to provide adverse-action notices when required and to use reports only for the stated purpose.</p>
        </Block>
        <Block n="04" title="Fees & billing">
          <p>Fees are billed per-screening or per-bundle. See the pricing page or your master service agreement.</p>
        </Block>
        <Block n="05" title="Data ownership">
          <p>You own the data you submit. NTN owns the platform, software, and aggregated/anonymous usage analytics.</p>
        </Block>
        <Block n="06" title="Liability">
          <p>NTN's aggregate liability for any claim is capped at amounts paid in the 12 months prior. NTN is not liable for indirect or consequential damages.</p>
        </Block>
        <Block n="07" title="Changes & contact">
          <p>We'll notify you in-product of material changes 30 days prior. Questions: legal@ntnverify.com.</p>
        </Block>
      </section>
      <footer className="border-t border-[#0A192F]/10 py-8 bg-[#F9F9F8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-xs text-[#4A5568] font-mono">
          © {new Date().getFullYear()} NATIONAL TENANT NETWORK · EFFECTIVE FEB 2026
        </div>
      </footer>
    </div>
  );
}
